import { NgModule, Inject } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard, HasChangesGuard, NewLocalWard, CampusUnitMessageComponent } from '../shared';
import * as Security from '../shared/tokens/roles.tokens';
import {
  HousingWardAssignmentsLookupComponent,
  HomeWardLookupComponent,
  HomeWardStudentComponent,
  CampusWardsComponent,
  HousingWardAssignmentsComponent,
  LocalWardAssignmentsLookupComponent,
  LocalWardAssignmentsComponent,
  CampusUnitProxyComponent,
  CampusStakesComponent,
  CampusUnitsCommunicationsComponent
} from '../admin';
import { NewQuestionDialogComponent } from './campus-units-communications/new-question-dialog/new-question-dialog.component';
import { NewSectionDialogComponent } from './campus-units-communications/new-section-dialog/new-section-dialog.component';

const routes: Routes = [
  {
    path: 'home-ward/students',
    component: HomeWardLookupComponent,
    data: { title: 'Lookup home unit' },
    children: [
      {
        path: ':identifier',
        component: HomeWardStudentComponent,
        data: { title: 'Update home unit' }
      }
    ]
  },
  {
    path: 'campus-wards',
    component: CampusWardsComponent,
    canDeactivate: [HasChangesGuard],
    data: { title: 'Manage campus wards' }
  },
  {
    path: 'campus-stakes',
    component: CampusStakesComponent,
    canDeactivate: [HasChangesGuard],
    data: { title: 'Manage campus stakes' }
  },
  {
    path: 'ward-assignments',
    children: [
      {
        path: 'housing',
        component: HousingWardAssignmentsLookupComponent,
        data: { title: 'Manage approved housing ward assignments' },
        children: [
          {
            path: ':sessionNumber',
            component: HousingWardAssignmentsComponent
          }
        ]
      },
      {
        path: 'local-wards',
        component: LocalWardAssignmentsLookupComponent,
        data: { title: 'Manage local ward assignments' },
        children: [
          {
            path: '',
            component: LocalWardAssignmentsComponent
          }
        ]
      }
    ]
  },
  {
    path: 'proxy',
    component: CampusUnitProxyComponent,
    data: { title: 'Proxy for a Campus Unit' }
  },
  {
    path: 'campus-units-communications',
    component: CampusUnitsCommunicationsComponent,
    data: { title: 'Frequently Asked Questions' },
    children: [
      {
        path: 'new-question',
        data: { title: 'new-question-dialog', breadcrumb: 'Question' },
        component: NewQuestionDialogComponent
      },
      {
        path: 'new-section',
        data: { title: 'new-section-dialog', breadcrumb: 'Sections' },
        component: NewSectionDialogComponent
      }
    ]
  },
  {
    path: 'notifications',
    component: CampusUnitMessageComponent,
    data: { title: 'Notifications' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule {}
